const mainState = {
  loading: false,
  error: false,
  isLoggedUser: false,
  message: "",
  user: null,
  isFullHeightPage: false,
  insurrances:[]
};

export default mainState;
